// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__1PH5-","footer":"ChangeClinic_footer__33-B1"};